var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"online-shop"},[_c('online_shop_component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }